module.exports = __webpack_public_path__ + "static/media/Square top.c9cc21a4.svg";